<template lang="pug">
  .appointmen
    Schedule(v-if="$store.state.showingSchedule")
    .preloader(v-if="!$store.state.showingSchedule")
      .loader
</template>

<script>
import Schedule from './components/Schedule'
export default {
  name: 'app',
  components: {
    Schedule
  },
  data () {
    return {}
  },
  mounted() {
    this.$store.dispatch('getAllClasses')
    this.$store.dispatch('getAllAppointments')
  }
}
</script>

<style lang="scss">
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .appointmen {
    position: relative;
    min-height: 80vh;
  }
  .preloader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: calc(80vh + 65px);
    z-index: 9999;
    background-color: rgba(#020814, .02);

    .loader {
      display: block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        background-color: #0477c6;
        left: 50%;
        right: 0;
        top: 0;
        bottom: 50%;
        -webkit-box-shadow: -.5em 0 0 #0477c6;
        box-shadow: -.5em 0 0 #0477c6;
        -webkit-animation: loader 1s linear infinite;
        animation: loader 1s linear infinite;
      }
      &:after {
        top: 50%;
        bottom: 0;
        -webkit-animation-delay: .25s;
        animation-delay: .25s;
      }
    }
  }
  @keyframes loader {
    0%,
    100% {
      -webkit-box-shadow: -.5em 0 0 transparent;
      box-shadow: -.5em 0 0 transparent;
      background-color: #0477c6;
    }
    50% {
      -webkit-box-shadow: -.5em 0 0 #0477c6;
      box-shadow: -.5em 0 0 #0477c6;
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue